import { Injectable, inject } from '@angular/core';
import { CardService } from './services/card.service';
import { StateService } from './services/state.service';

@Injectable({
  providedIn: 'root',
})
export class NonPaymentService {
  private state = inject(StateService);
  private cardService = inject(CardService);

  public getStatus(): 'expiresSoon' | 'expired' | 'couldntCharge' | 'enterpriseOverdue' {
    if (!this.state.card) return;
    const plan = this.state.plan;
    if (this.state.temporarilyHideUpgradeCta) return;
    if (!plan) return;
    if (plan.product.isFree) return;
    if (!['admin', 'owner'].includes(this.state.activeTenantRole)) return;
    // if (this.state.cardCreatedAt) {
    //   const cardCreatedAt = new Date(this.state.cardCreatedAt * 1000);
    //   const now = new Date();
    //   const diff = now.getTime() - cardCreatedAt.getTime();
    //   const days = diff / (1000 * 60 * 60 * 24);
    //   if (days < 4) return;
    // }

    if (plan.isEnterprise) {
      if (['unpaid', 'past_due'].includes(plan.status)) return 'enterpriseOverdue';
      return;
    }

    if (['unpaid', 'past_due'].includes(plan.status)) {
      return 'couldntCharge';
    }

    if (plan.status === 'active') {
      if (this.cardService.isExpired()) return 'expired';
      if (this.cardService.expiresSoon()) return 'expiresSoon';
    }
  }

  public isBlocked(): boolean {
    const plan = this.state.plan;
    if (!plan) return false;
    if (plan.isEnterprise) return false;
    const status = this.getStatus();
    if (status !== 'couldntCharge') return false;
    const endDate = plan.latestInvoicePeriodEnd;
    const daysSinceEnd = (new Date().getTime() - endDate) / (1000 * 60 * 60 * 24);
    return daysSinceEnd > 4;
  }
}
